export default __webpack_public_path__ + "static/media/expand.56f4bc84.svg";